//import { Promise } from "core-js";
import api from '@/app.js'

const state = {
    schedules: [],
}

const getters = {
    schedules: state => {
        return state.schedules;
    },
    isSchedules: state => {
        return state.schedules.length;
    },
}
const actions = {
    LOAD_SCHEDULES: function (context) {
        api.getSchedules().then(response => {
            context.commit("setSchedules", response);
        });
    },
    UPDATE_SCHEDULE: function (context, payload) {
        api.updateSchedule(payload).then(response => {
            if (response.count) context.commit("updateSchedule", payload);
        });
    },
    INSERT_SCHEDULE: function (context, payload) {
        api.insertSchedule(payload).then(response => {
            if (response.IDX) context.commit("insertSchedule", { ...payload, idx: response.IDX });
        });
    },
    DELETE_SCHEDULE: function (context, payload) {
        api.deleteSchedule(payload.idx).then(response => {
            if (response.count) context.commit("deleteSchedule", payload);
        });
    },
}

const mutations = {
    setSchedules: (state, payload) => {
        state.schedules = payload.data;
    },
    updateSchedule: (state, payload) => {
        let ind = -1;
        if (state.schedules.find((e, i) => { ind = i; return e.idx == payload.idx; })) Object.assign(state.schedules[ind], payload);
    },
    insertSchedule: (state, payload) => {
        state.schedules.push({ ...payload });
    },
    deleteSchedule: (state, payload) => {
        let ind = -1;
        if (state.schedules.find((e, i) => { ind = i; return e.idx == payload.idx; })) state.schedules.splice(ind, 1);
    },
}


const Schedules = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}

export default Schedules;